import { Component } from '@angular/core';
import {PostsService} from './posts.service';
// import 'global.ts';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'mca';
}
